/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import kotlin.time.Instant

/**
 * Conversion between FIT timestamps and [Instant].
 *
 * FIT counts seconds from 1989-12-31T00:00:00Z, not from the UNIX epoch.
 *
 * Values below [SYSTEM_TIME_THRESHOLD] are not wall-clock times at all: a device
 * that has not acquired a date yet writes seconds since power-on there. Those
 * cannot be turned into an [Instant] and come back as null.
 */
public object FitDateTime {
    /** Seconds between 1970-01-01T00:00:00Z and the FIT epoch. */
    public const val EPOCH_OFFSET_SECONDS: Long = Fit.EPOCH_OFFSET_SECONDS

    /** Below this, a timestamp is seconds since device power-on rather than a date. */
    public const val SYSTEM_TIME_THRESHOLD: UInt = 0x10000000u

    public fun toInstant(timestamp: UInt): Instant? {
        if (timestamp < SYSTEM_TIME_THRESHOLD) return null
        return Instant.fromEpochSeconds(timestamp.toLong() + EPOCH_OFFSET_SECONDS)
    }

    public fun toTimestamp(instant: Instant): UInt =
        (instant.epochSeconds - EPOCH_OFFSET_SECONDS).toUInt()

    /** True when [timestamp] is a device uptime rather than a date. */
    public fun isSystemTime(timestamp: UInt): Boolean = timestamp < SYSTEM_TIME_THRESHOLD
}
